import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  errorCodeSelector,
  containerCategoriesSelector,
  productCategoriesSelector,
  typeSelector,
  categorySelector,
  formatSelector,
  genreSelector,
  formatsSelector,
  genresSelector,
  priceRangeSelector,
  priceRangesSelector,
  productTypesSelector,
  warehouseTypesSelector,
  locationTypesSelector,
  containerTypesSelector,
  channelTypesSelector,
  acquisitionTypesSelector,
  receptionTypesSelector,
  productStatesSelector,
  productUsagesSelector,
  productFuntionalitiesSelector,
  productPackagingsSelector,
  productAestheticsSelector,
  productCompletenessesSelector,
  productAttributeSelector,
  containerRecipientTypesSelector,
} from './store/selector';
import { mastersApiService } from './services/api';
import {
  getTypesFailureApiAction,
  getTypesInitApiAction,
  getCategoriesInitApiAction,
  getCategoriesFailureApiAction,
  postTypeInitApiAction,
  postTypeSuccessApiAction,
  postTypeFailuireApiAction,
  postCategoryInitApiAction,
  postCategorySuccessApiAction,
  postCategoryFailuireApiAction,
  putTypeInitApiAction,
  putTypeSuccessApiAction,
  putTypeFailuireApiAction,
  putCategoryInitApiAction,
  putCategorySuccessApiAction,
  putCategoryFailuireApiAction,
  deleteTypeFailuireApiAction,
  deleteTypeSuccessApiAction,
  deleteTypeInitApiAction,
  deleteCategorySuccessApiAction,
  deleteCategoryInitApiAction,
  deleteCategoryFailuireApiAction,
  setCategoryAction,
  setTypeAction,
  setFormatAction,
  setGenreAction,
  getFormatsInitApiAction,
  getFormatsSuccessApiAction,
  getFormatsFailureApiAction,
  getGenresInitApiAction,
  getGenresSuccessApiAction,
  getGenresFailureApiAction,
  postFormatInitApiAction,
  postFormatSuccessApiAction,
  postFormatFailuireApiAction,
  postGenreInitApiAction,
  postGenreSuccessApiAction,
  postGenreFailuireApiAction,
  putFormatInitApiAction,
  putFormatSuccessApiAction,
  putFormatFailuireApiAction,
  putGenreInitApiAction,
  putGenreSuccessApiAction,
  putGenreFailuireApiAction,
  deleteFormatSuccessApiAction,
  deleteFormatFailuireApiAction,
  deleteGenreInitApiAction,
  deleteGenreSuccessApiAction,
  deleteGenreFailuireApiAction,
  getPriceRangesInitApiAction,
  getPriceRangesSuccessApiAction,
  getPriceRangesFailureApiAction,
  postPriceRangeInitApiAction,
  postPriceRangeSuccessApiAction,
  postPriceRangeFailuireApiAction,
  putPriceRangeFailuireApiAction,
  putPriceRangeSuccessApiAction,
  putPriceRangeInitApiAction,
  deletePriceRangeInitApiAction,
  deletePriceRangeSuccessApiAction,
  deletePriceRangeFailuireApiAction,
  setPriceRangeAction,
  getProductTypesSuccessApiAction,
  getWarehouseTypesSuccessApiAction,
  getLocationTypesSuccessApiAction,
  getContainerTypesSuccessApiAction,
  getChannelTypesSuccessApiAction,
  getProductCategoriesSuccessApiAction,
  getContainerCategoriesSuccessApiAction,
  getAcquisitionTypesSuccessApiAction,
  getReceptionTypesSuccessApiAction,
  getAttributesInitApiAction,
  getAttributesFailureApiAction,
  getProductUsagesSuccessApiAction,
  getProductPackagingsSuccessApiAction,
  getProductFuntionalitiesSuccessApiAction,
  getProductAestheticsSuccessApiAction,
  getProductCompletenessesSuccessApiAction,
  getProductStatesSuccessApiAction,
  postProductAttributeInitApiAction,
  postProductAttributeFailuireApiAction,
  postProductAttributeSuccessApiAction,
  putProductAttributeInitApiAction,
  putProductAttributeSuccessApiAction,
  putProductAttributeFailuireApiAction,
  updateAttributesOrderAction,
  deleteProductAttributeInitApiAction,
  deleteProductAttributeSuccessApiAction,
  deleteProductAttributeFailuireApiAction,
  setProductAttributeAction,
  getContainerRecipientTypesSuccessApiAction,
} from './store/reducer';
import { PostTypePayloadRequest } from './interfaces/post-type';
import { PutTypePayloadRequest } from './interfaces/put-type';
import { PutCategoryPayloadRequest } from './interfaces/put-category';
import { Category } from '../../interfaces/category.interface';
import { Type } from '../../interfaces/type.interface';
import { Format } from '../../interfaces/format.interface';
import { Genre } from '../../interfaces/genre.interface';
import { PostFormatPayloadRequest } from './interfaces/post-format';
import { PostGenrePayloadRequest } from './interfaces/post-genre';
import { PutFormatPayloadRequest } from './interfaces/put-format';
import { PutGenrePayloadRequest } from './interfaces/put-genre';
import { PostPriceRangePayloadRequest } from './interfaces/post-price-range';
import { PutPriceRangePayloadRequest } from './interfaces/put-price-range';
import { PriceRange } from '../../interfaces/priceRange.interface';
import { PostProductCategoryPayloadRequest } from './interfaces/post-product-category';
import { PostContainerCategoryPayloadRequest } from './interfaces/post-container-category';
import { PostProductAttributeValuePayloadRequest } from './interfaces/post-product-attribute-value';
import { PutProductAttributeValuePayloadRequest } from './interfaces/put-product-attribute-value';
import { ProductAttribute } from '../../interfaces/productAttribute.interface';

export type tType = 'product' | 'warehouse' | 'location' | 'channel' | 'container' | 'acquisition' | 'reception' | 'containerRecipient';
export type tAttribute = 'usage' | 'functionality' | 'packaging' | 'aesthetic' | 'completeness' | 'state' ;

export function useMasterCore() {
  const productTypes = useSelector(productTypesSelector);
  const warehouseTypes = useSelector(warehouseTypesSelector);
  const locationTypes = useSelector(locationTypesSelector);
  const containerTypes = useSelector(containerTypesSelector);
  const channelTypes = useSelector(channelTypesSelector);
  const acquisitionTypes = useSelector(acquisitionTypesSelector);
  const receptionTypes = useSelector(receptionTypesSelector);
  const productCategories = useSelector(productCategoriesSelector);
  const containerCategories = useSelector(containerCategoriesSelector);
  const productUsages = useSelector(productUsagesSelector);
  const productPackagings = useSelector(productPackagingsSelector);
  const productFuntionalities = useSelector(productFuntionalitiesSelector);
  const productAesthetics = useSelector(productAestheticsSelector);
  const productCompletenesses = useSelector(productCompletenessesSelector);
  const productStates = useSelector(productStatesSelector);
  const formats = useSelector(formatsSelector);
  const genres = useSelector(genresSelector);
  const priceRanges = useSelector(priceRangesSelector);
  const errorCode = useSelector(errorCodeSelector);
  const type = useSelector(typeSelector);
  const productAttribute = useSelector(productAttributeSelector);
  const category = useSelector(categorySelector);
  const format = useSelector(formatSelector);
  const genre = useSelector(genreSelector);
  const priceRange = useSelector(priceRangeSelector);
  const containerRecipientTypes = useSelector(containerRecipientTypesSelector);
  const dispatch = useDispatch();

  const getTypes = useCallback(
    async (
      id: number,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getTypesInitApiAction());
        if (type === 'product') {
          const response = await mastersApiService.getProductTypes(id)
          dispatch(getProductTypesSuccessApiAction(response));
        } else if (type === 'warehouse') {
          const response = await mastersApiService.getWarehouseTypes(id);
          dispatch(getWarehouseTypesSuccessApiAction(response));
        } else if (type === 'location') {
          const response = await mastersApiService.getLocationTypes(id);
          dispatch(getLocationTypesSuccessApiAction(response));
        } else if (type === 'container') {
          const response = await mastersApiService.getContainerTypes(id);
          dispatch(getContainerTypesSuccessApiAction(response));
        } else if (type === 'channel') {
          const response = await mastersApiService.getChannelTypes(id);
          dispatch(getChannelTypesSuccessApiAction(response));
        } else if (type === 'acquisition') {
          const response = await mastersApiService.getAcquisitionTypes(id);
          dispatch(getAcquisitionTypesSuccessApiAction(response));
        } else if (type === 'reception') {
          const response = await mastersApiService.getReceptionTypes(id);
          dispatch(getReceptionTypesSuccessApiAction(response));
        } else if (type === 'containerRecipient') {
          dispatch(getTypesInitApiAction());
          const response = await mastersApiService.getContainerRecipientTypes(id);
          dispatch(getContainerRecipientTypesSuccessApiAction({
            containerRecipientTypes: response.containerRecipientTypes
          }));
        }
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getTypesFailureApiAction({ errorCode: error?.request?.status || 500 })
        );
      }
    },
    [dispatch]
  );

  const getProductAttributes = useCallback(
    async (
      id: number,
      type: tAttribute,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getAttributesInitApiAction());
        if (type === 'usage') {
          const response = await mastersApiService.getProductUsages(id)
          dispatch(getProductUsagesSuccessApiAction(response));
        } else if (type === 'packaging') {
          const response = await mastersApiService.getProductPackagings(id);
          dispatch(getProductPackagingsSuccessApiAction(response));
        } else if (type === 'functionality') {
          const response = await mastersApiService.getProductFuntionalities(id);
          dispatch(getProductFuntionalitiesSuccessApiAction(response));
        } else if (type === 'aesthetic') {
          const response = await mastersApiService.getProductAesthetics(id);
          dispatch(getProductAestheticsSuccessApiAction(response));
        } else if (type === 'completeness') {
          const response = await mastersApiService.getProductCompletenesses(id);
          dispatch(getProductCompletenessesSuccessApiAction(response));
        } else if (type === 'state') {
          const response = await mastersApiService.getProductStates(id);
          dispatch(getProductStatesSuccessApiAction(response));
        }
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getAttributesFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getCategories = useCallback(
    async (
      id: number,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getCategoriesInitApiAction());
        if (type === 'product') {
          const response = await mastersApiService.getProductCategories(id);
          dispatch(getProductCategoriesSuccessApiAction(response));
        } else if (type === 'container') {
          const response = await mastersApiService.getContainerCategories(id);
          dispatch(getContainerCategoriesSuccessApiAction(response));
        }
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getCategoriesFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getFormats = useCallback(
    async (
      id: number,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getFormatsInitApiAction());
        const response = await mastersApiService.getFormats(id);
        dispatch(getFormatsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getFormatsFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getGenres = useCallback(
    async (
      id: number,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getGenresInitApiAction());
        const response = await mastersApiService.getGenres(id);
        dispatch(getGenresSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getGenresFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getPriceRanges = useCallback(
    async (
      id: number,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getPriceRangesInitApiAction());
        const response = await mastersApiService.getPriceRanges(id);
        dispatch(getPriceRangesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getPriceRangesFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postType = useCallback(
    async (
      id: number,
      data: PostTypePayloadRequest,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postTypeInitApiAction());
        if (type === 'product') {
          await mastersApiService.postProductType(id, data);
        } else if (type === 'warehouse') {
          await mastersApiService.postWarehouseType(id, data);
        } else if (type === 'location') {
          await mastersApiService.postLocationType(id, data);
        } else if (type === 'container') {
          await mastersApiService.postContainerType(id, data);
        } else if (type === 'channel') {
          await mastersApiService.postChannelType(id, data);
        } else if (type === 'acquisition') {
          await mastersApiService.postAcquisitionType(id, data);
        } else if (type === 'reception') {
          await mastersApiService.postReceptionType(id, data);
        } else if (type === 'containerRecipient') {
          await mastersApiService.postContainerRecipientType(id, data);
        }
        dispatch(postTypeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          postTypeFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postProductAttibute = useCallback(
    async (
      id: number,
      data: PostProductAttributeValuePayloadRequest,
      type: tAttribute,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postProductAttributeInitApiAction());
        if (type === 'usage') {
          await mastersApiService.postProductUsage(id, data)
        } else if (type === 'packaging') {
          await mastersApiService.postProductPackaging(id, data);
        } else if (type === 'functionality') {
          await mastersApiService.postProductFuntionality(id, data);
        } else if (type === 'aesthetic') {
          await mastersApiService.postProductAesthetic(id, data);
        } else if (type === 'completeness') {
          await mastersApiService.postProductCompleteness(id, data);
        } else if (type === 'state') {
          await mastersApiService.postProductState(id, data);
        }
        dispatch(postProductAttributeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          postProductAttributeFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postCategory = useCallback(
    async (
      id: number,
      body: PostProductCategoryPayloadRequest | PostContainerCategoryPayloadRequest,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postCategoryInitApiAction());
        if (type === 'product') {
          await mastersApiService.postProductCategory(id, body as PostProductCategoryPayloadRequest);
        } else if (type === 'container') {
          await mastersApiService.postContainerCategory(id, body as PostContainerCategoryPayloadRequest);
        }
        dispatch(postCategorySuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          postCategoryFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postFormat = useCallback(
    async (
      id: number,
      data: PostFormatPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postFormatInitApiAction());
        await mastersApiService.postFormat(id, data);
        dispatch(postFormatSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          postFormatFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postGenre = useCallback(
    async (
      id: number,
      data: PostGenrePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postGenreInitApiAction());
        await mastersApiService.postGenre(id, data);
        dispatch(postGenreSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          postGenreFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postPriceRange = useCallback(
    async (
      id: number,
      data: PostPriceRangePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postPriceRangeInitApiAction());
        await mastersApiService.postPriceRange(id, data);
        dispatch(postPriceRangeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          postPriceRangeFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putType = useCallback(
    async (
      cId: number,
      tId: number,
      body: PutTypePayloadRequest,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putTypeInitApiAction());
        if (type === 'product') {
          await mastersApiService.putProductType(cId, tId, body);
        } else if (type === 'warehouse') {
          await mastersApiService.putWarehouseType(cId, tId, body);
        } else if (type === 'location') {
          await mastersApiService.putLocationType(cId, tId, body);
        } else if (type === 'container') {
          await mastersApiService.putContainerType(cId, tId, body);
        } else if (type === 'channel') {
          await mastersApiService.putChannelType(cId, tId, body);
        } else if (type === 'acquisition') {
          await mastersApiService.putAcquisitionType(cId, tId, body);
        } else if (type === 'reception') {
          await mastersApiService.putReceptionType(cId, tId, body);
        } else if (type === 'containerRecipient') {
          await mastersApiService.putContainerRecipientType(cId, tId, body);
        }
        dispatch(putTypeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putTypeFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putProductAttibute = useCallback(
    async (
      cId: number,
      aId: number,
      data: PutProductAttributeValuePayloadRequest,
      type: tAttribute,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putProductAttributeInitApiAction());
        if (type === 'usage') {
          await mastersApiService.putProductUsage(cId, aId, data)
        } else if (type === 'packaging') {
          await mastersApiService.putProductPackaging(cId, aId, data);
        } else if (type === 'functionality') {
          await mastersApiService.putProductFuntionality(cId, aId, data);
        } else if (type === 'aesthetic') {
          await mastersApiService.putProductAesthetic(cId, aId, data);
        } else if (type === 'completeness') {
          await mastersApiService.putProductCompleteness(cId, aId, data);
        } else if (type === 'state') {
          await mastersApiService.putProductState(cId, aId, data);
        }
        dispatch(putProductAttributeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putProductAttributeFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putCategory = useCallback(
    async (
      cId: number,
      tId: number,
      body: PutCategoryPayloadRequest,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putCategoryInitApiAction());
        if (type === 'product') {
          await mastersApiService.putProductCategory(cId, tId, body);
        } else if (type === 'container') {
          await mastersApiService.putContainerCategory(cId, tId, body);
        }
        dispatch(putCategorySuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putCategoryFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putFormat = useCallback(
    async (
      cId: number,
      tId: number,
      body: PutFormatPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putFormatInitApiAction());
        await mastersApiService.putFormat(cId, tId, body);
        dispatch(putFormatSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putFormatFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putGenre = useCallback(
    async (
      cId: number,
      tId: number,
      body: PutGenrePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putGenreInitApiAction());
        await mastersApiService.putGenre(cId, tId, body);
        dispatch(putGenreSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putGenreFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putPriceRange = useCallback(
    async (
      cId: number,
      tId: number,
      body: PutPriceRangePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putPriceRangeInitApiAction());
        await mastersApiService.putPriceRange(cId, tId, body);
        dispatch(putPriceRangeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putPriceRangeFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const deleteType = useCallback(
    async (
      cId: number,
      tId: number,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteTypeInitApiAction());
        if (type === 'product') {
          await mastersApiService.deleteProductType(cId, tId);
        } else if (type === 'warehouse') {
          await mastersApiService.deleteWarehouseType(cId, tId);
        } else if (type === 'location') {
          await mastersApiService.deleteLocationType(cId, tId);
        } else if (type === 'container') {
          await mastersApiService.deleteContainerType(cId, tId);
        } else if (type === 'channel') {
          await mastersApiService.deleteChannelType(cId, tId);
        } else if (type === 'acquisition') {
          await mastersApiService.deleteAcquisitionType(cId, tId);
        } else if (type === 'reception') {
          await mastersApiService.deleteReceptionType(cId, tId);
        } else if (type === 'containerRecipient') {
          await mastersApiService.deleteContainerRecipientType(cId, tId);
        }
        dispatch(deleteTypeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteTypeFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteProductAttibute = useCallback(
    async (
      cId: number,
      aId: number,
      type: tAttribute,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteProductAttributeInitApiAction());
        if (type === 'usage') {
          await mastersApiService.deleteProductUsage(cId, aId)
        } else if (type === 'packaging') {
          await mastersApiService.deleteProductPackaging(cId, aId);
        } else if (type === 'functionality') {
          await mastersApiService.deleteProductFuntionality(cId, aId);
        } else if (type === 'aesthetic') {
          await mastersApiService.deleteProductAesthetic(cId, aId);
        } else if (type === 'completeness') {
          await mastersApiService.deleteProductCompleteness(cId, aId);
        } else if (type === 'state') {
          await mastersApiService.deleteProductState(cId, aId);
        }
        dispatch(deleteProductAttributeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          deleteProductAttributeFailuireApiAction()
        );
      }
    },
    [dispatch]
  );

  const deleteCategory = useCallback(
    async (
      cId: number,
      tId: number,
      type: tType,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteCategoryInitApiAction());
        if (type === 'product') {
          await mastersApiService.deleteProductCatergory(cId, tId);
        } else if (type === 'container') {
          await mastersApiService.deleteContainerCatergory(cId, tId);
        }
        dispatch(deleteCategorySuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteCategoryFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteFormat = useCallback(
    async (
      cId: number,
      tId: number,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteTypeInitApiAction());
        await mastersApiService.deleteFormat(cId, tId);
        dispatch(deleteFormatSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteFormatFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteGenre = useCallback(
    async (
      cId: number,
      tId: number,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteGenreInitApiAction());
        await mastersApiService.deleteGenre(cId, tId);
        dispatch(deleteGenreSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteGenreFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deletePriceRange = useCallback(
    async (
      cId: number,
      tId: number,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deletePriceRangeInitApiAction());
        await mastersApiService.deletePriceRange(cId, tId);
        dispatch(deletePriceRangeSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deletePriceRangeFailuireApiAction());
      }
    },
    [dispatch]
  );

  const setCategory = useCallback((category: Category | null) => {
    dispatch(setCategoryAction(category));
  }, [dispatch]);

  const setType = useCallback((type: Type | null) => {
    dispatch(setTypeAction(type));
  }, [dispatch]);

  const setProductAttribute = useCallback((attribute: ProductAttribute | null) => {
    dispatch(setProductAttributeAction(attribute));
  }, [dispatch]);

  const setFormat = useCallback((format: Format | null) => {
    dispatch(setFormatAction(format));
  }, [dispatch]);

  const setGenre = useCallback((genre: Genre | null) => {
    dispatch(setGenreAction(genre));
  }, [dispatch]);

  const setPriceRange = useCallback((priceRange: PriceRange | null) => {
    dispatch(setPriceRangeAction(priceRange));
  }, [dispatch]);

  const clearError = useCallback(() => {
    dispatch(getTypesInitApiAction());
  }, [dispatch]);

  const updateAttributesOrder = useCallback(
    (type: tAttribute, items: ProductAttribute[]) => {
      dispatch(updateAttributesOrderAction({ type, items }));
    },
    [dispatch]
  );

  return {
    productTypes,
    productUsages,
    productAesthetics,
    productCompletenesses,
    productFuntionalities,
    productPackagings,
    productStates,
    warehouseTypes,
    locationTypes,
    containerTypes,
    channelTypes,
    acquisitionTypes,
    receptionTypes,
    containerRecipientTypes,
    productCategories,
    containerCategories,
    formats,
    genres,
    priceRanges,
    type,
    productAttribute,
    category,
    format,
    genre,
    priceRange,
    errorCode,
    getTypes,
    getProductAttributes,
    getCategories,
    getFormats,
    getGenres,
    getPriceRanges,
    postType,
    postProductAttibute,
    postCategory,
    postFormat,
    postGenre,
    postPriceRange,
    putType,
    putProductAttibute,
    putCategory,
    putFormat,
    putGenre,
    putPriceRange,
    deleteType,
    deleteProductAttibute,
    deleteCategory,
    deleteFormat,
    deleteGenre,
    deletePriceRange,
    setCategory,
    setType,
    setProductAttribute,
    setGenre,
    setFormat,
    setPriceRange,
    clearError,
    updateAttributesOrder,
  };
}
